import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CTA_LABEL, site } from '../data/site';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-16 bg-brand-alt px-4 py-16 md:py-24" data-id="element-140" data-mp="19gt4m4mwprfe">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-141" data-mp="1eg5msc2u2abn">
        <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-142" data-mp="1ja0fg50f1zmv">LIMITED-TIME PRICE</p>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-143" data-mp="1n9r3i0yk61np">Special Launch Offer</h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-orange bg-brand-alt p-7 pt-10 shadow-[0_18px_50px_rgba(18,58,99,0.10)] md:p-12" data-id="element-144" data-mp="1s82am3xgxy28">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-145" data-mp="2282ym36a92cr">
            PE READY
          </div>
          <div className="space-y-4 text-left" data-id="element-146" data-mp="7u21bmqdsnes">
            <PriceLine label="10 Complete Volumes (Elementary + Secondary)" price={site.valueVolumes} data-id="element-147" data-mp="1mh6jevyhww3v" />
            <PriceLine label="5 Exclusive Bonuses" price={site.valueBonuses} data-id="element-148" data-mp="1hpg389cvne4j" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-149" data-mp="1cqv46d9d30ho">
              <span data-id="element-150" data-mp="17saeh7rqjz7h">TOTAL VALUE:</span>
              <span className="text-brand-gray line-through" data-id="element-151" data-mp="17td47cdbnvlt">{site.totalValue}</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-152" data-mp="25er6pylm3mmd">
            <p className="text-[11px] font-extrabold tracking-[0.16em] text-brand-teal" data-id="element-153" data-mp="20hhc84jd8kro">TODAY ONLY</p>
            <p className="mt-2 font-serif text-5xl font-black tracking-tight text-brand-blue md:text-6xl" data-id="element-154" data-mp="1vgbdnq30y3a8">
              {site.currentPrice} <span className="text-2xl" data-id="element-155" data-mp="1rfhq4xthuqhv">{site.currency}</span>
            </p>
          </div>
          <CTAButton href={site.checkoutUrl} className="w-full py-4 text-base md:text-lg" data-id="element-156" data-mp="k3ircut0671k">
            {CTA_LABEL}
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-157" data-mp="hi193tdbhqfn">
            One-time payment · Instant digital access · Lifetime access
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-dark pb-4 text-sm" data-id="element-158" data-mp="7ly5sk6qblr4">
      <span className="font-medium" data-id="element-159" data-mp="3uwo5g7aer501">{label}</span>
      <span className="shrink-0 font-bold text-brand-blue" data-id="element-160" data-mp="3uvw92u8zl38p">{price}</span>
    </div>;
}